import React from "react";

export const PageShell = ({ children, className = "" }) => {
  return (
    <div
      className={`kid-bg ${className}`}
      style={{
        height: "100vh",
        // @ts-ignore – dynamic viewport height for mobile (fallback above)
        minHeight: "100dvh",
        maxHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          overscrollBehavior: "contain",
        }}
      >
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-5 sm:pt-8 pb-6" style={{ overflowX: "hidden" }}>
          {children}
        </div>
      </div>
      {/* Bottom cream band is provided globally by body::after in App.css */}
    </div>
  );
};

export default PageShell;
